const permissionsMap = {
    2: 'enableUsers',
    3: 'enableMovements',
    4: 'enableProduct',
    5: 'enablePaymentLinks',
    6: 'enablePaymentMovements',
    7: 'enableCancellations',
    9: 'enableFunctionalities',
    10: 'enableAccounts',
};

export default permissionsMap;
